<template>
    <div class="basic_wrap">
        <div class="m-flex red-top-nav">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{ $t('用户协议') }}</div>
        </div>
        <div class="contract-wrap m-pd1">
            <div class="m-flex m-f-center">
                <p class="h4">{{$t('xy1')}}</p>
            </div>
            <p class="h3">
                {{$t('xy2')}}
            </p>
            <p class="h3"> {{$t('xy3')}}</p>
            <p>
                {{$t('xy4')}}
             </p>
             <p class="h3"> {{$t('xy5')}}</p>
             <p>
                {{$t('xy6')}}
             </p>
             <p class="h3"> {{$t('xy7')}}</p>
             <p>
                {{$t('xy8')}}
             </p>
             <p class="h3"> {{$t('xy9')}}</p>
             <p>
                {{$t('xy10')}}
             </p>
             <p class="h3"> {{$t('xy11')}}</p>
             <p>
                {{$t('xy12')}}
             </p>
             <p class="h3"> {{$t('xy13')}}</p>
             <p>
                {{$t('xy14')}}
             </p>
             <p class="h3"> {{$t('xy15')}}</p>
             <p>
                {{$t('xy16')}}
             </p>
             
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {
    Empty
} from "vant";

import Fetch from "../../utils/fetch";
Vue.use(Empty);

export default {
    name: "order",
    data() {
        return {
            lang: this.$i18n.locale || "en_us",
            info: {}
        };
    },
    created() {
    },
    mounted() {
    },
    computed: {
        time() {
            const time = this.$route.query.time
            let date = new Date(time * 1),
                year = date.getFullYear(),
                month = date.getMonth() + 1,
                strDate = date.getDate()
            if (month < 10) month = `0${month}`
            if (strDate < 10) strDate = `0${strDate}`
            return `${year}-${month}-${strDate}`
        }
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
.contract-wrap {

    &>p,
    &>div {
        margin: .5em 0;
    }

    p {
        font-size: 14px;
        line-height: 18px;

        &.h3 {
            font-size: 16px;
            text-indent: 0;
        }

        &.h4 {
            font-size: 18px;
            text-indent: 0;
        }
    }
}
.big_tit {
    white-space: nowrap;
}
</style>
